import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { usePluginProvider, useAuthProvider, Loader, DataContext, CloudPremisePluginManager } from '@cloudpremise/portal_core';
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import UploadModal from "../components/UploadModal";
import PdfViewer from "@cloudpremise/portal_core/src/themes/mui/components/PdfViewer";
import FileViewerModal from "../components/FileViewerModal";

import { Box, Button, Modal, Typography, Grid, Card, CardContent, Collapse, List, CardActionArea } from '@mui/material';
import { S3 } from 'aws-sdk';
import Dropzone from 'react-dropzone';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import "../styles/filemanager.scss";
import Config from '../../../../Config';

const Home = (props: any) => {
    const navigate = useNavigate();
    const dataProvider = useContext(DataContext);
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const [ authorized, authType, token ] = useAuthProvider();
    const pluginManager: CloudPremisePluginManager = usePluginProvider();
    const fileManagerPlugin = pluginManager.getPluginByName("@cloudpremise/portal_filemanager");
    const s3: S3 = fileManagerPlugin.getAwsClient();
    const defaultPath = Config.getAwsBucketDefaultPath();

    const defaultState = {
        path: Config.getAwsBucketDefaultPath(),
        loading: false,
        files: [],
        uploadModal: false,
        uploadPath: "",
        uploading: false,
        pdfModal: false,
        pdfData: null,
        fileViewerModal: false,
        objectUrl: "",
        loadingFile: null,
        mimeType: ""
    };
    
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const backPath = getBackPath(state.path);
    const bucketName = Config.getAwsBucket();

    useEffect(() => {
        if(!authorized){
            return navigate("/landing"+window.location.search, { replace: true });
        }
        fetchFiles(state.path);
    }, [state.path]);

    const fetchFiles = (folder) => {
        if(folder === "/"){
            folder = "";
        }
        const params = {
            Bucket: bucketName,
            Prefix: folder,
            Delimiter: '/',
        };

        s3.listObjectsV2(params, (err, data) => {
            if (err) {
                console.error('Error fetching files:', err);
            } else {
                let items = [];
                // Process folders from the CommonPrefixes section
                if (data.CommonPrefixes) {
                    data.CommonPrefixes.forEach((prefix) => {
                        items.push({
                            key: prefix.Prefix,
                            isFolder: true,
                            upload: true,
                            displayName: prefix.Prefix.replace(folder, '').replace('/', ''),
                        });
                    });
                }
                data.Contents.map((item) => {
                    if(!item.Key.endsWith('/')){
                        items.push({
                            key: item.Key,
                            isFolder: false,
                            upload: false,
                            displayName: item.Key.split("/").pop()
                        });
                    }
                });
                setState({
                    loading: false,
                    files: items
                });
            }
        });
        setState({
            path: folder,
            loading: true,
            uploadModal: false,
            uploadPath: "",
            uploading: false
        });
    };

    function getBackPath(path){
        if(typeof(path) !== "string" || path.trim().length <= 0){
            return "";
        }
        if(path.length <= 1 || path.trim() === "/"){
            return "";
        }
        // if(path.substr(0, 1) !== "/"){
        //     path += "/";
        // }
        if(path === defaultPath){
            return "";
        }
        console.log("path = "+path+" defaultPath = "+defaultPath);
        path = decodeURIComponent(path.trim()); //Decode path
        path = path.replace(/^\/+|\/+$/g, ''); //Remove trailing slash
        const pathArray = path.split("/");
        pathArray.pop();
        let backPath = pathArray.join("/");
        if(backPath.length <= 0){
            backPath = "/";
        }
        return backPath;
    }

    const openFolder = (folderKey) => {
        fetchFiles(folderKey);
    };

    const handleUploadClick = (folderKey) => {
        setState({
            uploadPath: folderKey,
            uploadModal: true
        });
    };

    const handleFileUpload = (acceptedFiles) => {
        let filesCount = acceptedFiles.length;
        let processCount = 0;
        acceptedFiles.forEach((file) => {
            const params = {
                Bucket: bucketName,
                Key: `${state.uploadPath}${file.name}`,
                Body: file,
            };

            s3.upload(params, (err, data) => {
                processCount++;
                if(filesCount === processCount){
                    fetchFiles(state.path);
                }
            });
        });
        setState({
            uploading: true,
        });
    };
    // Helper function to determine content type
    const determineContentType = (fileKey) => {
        if (fileKey.endsWith('.html')) return 'text/html';
        if (fileKey.endsWith('.jpg') || fileKey.endsWith('.jpeg') || fileKey.endsWith('.JPG')) return 'image/jpeg';
        if (fileKey.endsWith('.png')) return 'image/png';
        if (fileKey.endsWith('.mp4')) return 'video/mp4';
        if (fileKey.endsWith('.txt')) return 'text/plain';
        return 'application/octet-stream';  // Default fallback
    };
    const onFileOpen = (fileKey) => {
        const params = {
            Bucket: bucketName,
            Key: fileKey,
            ResponseContentDisposition: 'inline',  // Ensure inline preview instead of download
            ResponseContentType: determineContentType(fileKey)  // Determine MIME type based on file extension
        };
      
        s3.getObject(params, (err, data: any) => {
            if (err) {
                console.error('Error fetching file contents:', err);
            } else {
                
                
                if (fileKey.endsWith('.pdf')) {
                    const uint8Array: Uint8Array = new Uint8Array(data.Body);
                    let binary = '';
                    for (let i = 0; i < uint8Array.length; i++) {
                        binary += String.fromCharCode(uint8Array[i]);
                    }
                    const base64String = btoa(binary); // Convert binary data to base64
                    setState({
                        loadingFile: null,
                        pdfModal: true,
                        pdfData: base64String
                    });
                }else{
                    const mimeType = determineContentType(fileKey);
                    const objectUrl = URL.createObjectURL(new Blob([new Uint8Array(data.Body)], { type: mimeType }));
                    setState({
                        loadingFile: null,
                        fileViewerModal: true,
                        objectUrl: objectUrl,
                        mimeType: mimeType
                    });
                }
            }
        });
        setState({
            loadingFile: fileKey,
            fileViewerModal: false,
            objectUrl: "",
            pdfModal: false,
            pdfData: null
        });
    }

    const renderFile = (file) => {
        return (
            <MDBox>
                {
                    file.isFolder ?
                        <CardActionArea className="document-folder__heading">
                            <FolderOutlinedIcon />
                            <MDTypography variant="h6" component="h6" mb={2} onClick={() => openFolder(file.key)}>
                                {file.displayName}
                            </MDTypography>
                            {
                                file.upload ?
                                    <FileUploadOutlinedIcon onClick={() => handleUploadClick(file.key)} />
                                :
                                    null
                            }
                        </CardActionArea>
                    :
                        <CardActionArea className="document-folder__heading">
                            <FolderOutlinedIcon />
                            <MDTypography variant="h6" component="h6" mb={2}>
                                {file.displayName}
                            </MDTypography>
                            {
                                state.loadingFile === file.key ?
                                    <Loader color="info" size={18} />
                                :
                                    <RemoveRedEyeOutlinedIcon onClick={() => onFileOpen(file.key)} />
                            }
                        </CardActionArea>
                }
            </MDBox>
        )
    }
    
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                {/* <Typography variant="h4" gutterBottom>
                    AWS S3 File Manager
                </Typography> */}
                <Grid container justifyContent="center" alignItems="flex-start">
                    <Grid item xs={12} md={12} lg={12} ml="auto" mr="auto" position="relative">
                        <Card sx={{padding: "24px"}}>
                            <MDTypography variant="h3" component="h2" fontWeight="medium" mb={2} sx={{display: "flex", justifyContent: "space-between"}}>
                                <div>File Manager</div>
                                <MDButton variant="gradient" color="info" onClick={() => handleUploadClick(state.path)}>
                                    Upload
                                </MDButton>
                            </MDTypography>
                            {
                                !state.loading ?
                                    <MDBox className='documents'>
                                        {
                                            backPath.length > 0 ?
                                                renderFile({
                                                    key: backPath,
                                                    displayName: "...",
                                                    isFolder: true,
                                                    upload: false,
                                                })
                                            :
                                                null
                                        }
                                        {state.files.map((file) => renderFile(file))}
                                    </MDBox>
                                :
                                    <Loader color="info" />
                            }
                        </Card>
                    </Grid>
                </Grid>
                {
                    state.uploadModal ?
                        <UploadModal
                            open={state.uploadModal}
                            folder={state.uploadPath}
                            uploading={state.uploading}
                            onCancel={() => setState({uploadModal: false})}
                            onSuccess={(files) => handleFileUpload(files)}
                        />
                    :
                        null
                }
                {
                    state.pdfModal ?
                        <PdfViewer
                            open={state.pdfModal}
                            width="1024px"
                            maxWidth="none"
                            onClose={() => setState({pdfModal: false, pdfData: null})}
                            title="Pdf Viewer"
                            data={state.pdfData}
                        />
                    :
                    null
                }
                {
                    state.fileViewerModal ?
                        <FileViewerModal
                            open={state.fileViewerModal}
                            onCancel={() => setState({fileViewerModal: false})}
                            objectUrl={state.objectUrl}
                            mimeType={state.mimeType}
                        />
                    :
                    null
                }
            </MDBox>
        </DashboardLayout>
    );
};

export default Home;
